// extracted by mini-css-extract-plugin
export default {"errorMessage":"signUp_errorMessage__GxpjX","formCheckbox":"signUp_formCheckbox__9KaxH"};